import {
    GET_ROYALTY_CONTRACT_SUCCESS,
    FETCH_START,
    FETCH_END,
} from '../../actions/Royalty/ActionTypes';
const initialState = {
    loading: false,
    calculationResult: [],
};

const RoyaltyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ROYALTY_CONTRACT_SUCCESS:
            return {
                ...state,
                royaltyContractSuccess: action.data,
                loading: false,
            };
        case FETCH_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default RoyaltyReducer;
